import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { I as InnerSwitchWrapper, S as SliderButton, C as Checkmark } from './InnerSwitch.styles-ChC_OShs.js';
import { c as check } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const InnerSwitch = ({
  className,
  disabled = false,
  id,
  onChange = noop,
  small = false,
  switchLabel,
  toggled = false,
  ...rest
}) => {
  const handleOnChange = event => {
    // aria-checked has a string value, so we convert to a bool and then negate it.
    onChange(!(event.currentTarget.getAttribute('aria-checked') === 'true'), event);
  };
  const size = small ? 'small' : 'base';
  return /*#__PURE__*/React__default.createElement(InnerSwitchWrapper, {
    className: className,
    $disabled: disabled,
    $size: size
  }, /*#__PURE__*/React__default.createElement(SliderButton, _extends({
    id: id,
    "aria-label": switchLabel,
    role: "switch",
    onClick: handleOnChange,
    "aria-checked": toggled,
    disabled: disabled,
    type: "button",
    $size: size,
    $toggled: toggled
  }, rest), /*#__PURE__*/React__default.createElement(Checkmark, {
    type: check,
    $toggled: toggled,
    $disabled: disabled,
    $size: size,
    "aria-hidden": true
  })));
};
InnerSwitch.displayName = 'InnerSwitch';

export { InnerSwitch as I };
//# sourceMappingURL=InnerSwitch-CReAd05B.js.map
